/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

const IndexItem = styled.div`
  display: flex;
  width: 260px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  background-color: var(--component-color-fill-alternative);
`;

const ItemsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

const Item = styled.div`
  display: flex;
  width: 80px;
  box-sizing: border-box;
  padding: 16px 10px;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const DATA = ["Owner", "Super Admin", "Policy Admin", "Security Admin", "Staff"];

const PermissionTableHeaderRow = () => {
  return (
    <Container>
      <IndexItem>
        <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
          역할
        </UI.Typography>
      </IndexItem>
      <ItemsContainer>
        {DATA.map((item, index) => (
          <Item key={index}>
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-normal)">
              {item}
            </UI.Typography>
          </Item>
        ))}
      </ItemsContainer>
    </Container>
  );
};

export default PermissionTableHeaderRow;
